import React, {useState, useEffect, useRef} from 'react'
import {SemiTransparentButton} from 'components/CustomButton'
import {useDispatch, useSelector} from 'react-redux'
import {getShifts, updateShift} from 'redux/slices/shiftSlice'
import CustomModal from 'components/CustomModal'

import CustomCard from '../../components/card/CustomCard'
import CustomCardHeader from '../../components/card/CustomCardHeader'
import CampaignShiftForm from './components/CampaignShiftForm'
import CustomButton from 'components/CustomButton'
import ShiftList from './components/Shiftlist'
import {getCampaigns, createShift} from 'redux/slices/shiftSlice'
import {removeShift} from 'redux/slices/shiftSlice'
import {isEmpty} from 'lodash'
import TableItemLoader from '../../components/TableItemLoader'
import {
  timeToUTCTimeString,
  utcToLocalTimeString,
} from '../../helpers/dateTimeHelper'
import AssociatedBookings from './components/AssociatedBookings'
import {capitalizeFirstLetter} from "../../helpers/stringHelper";

const Shifts = () => {
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(false)

  const [shift, setSelectedShift] = useState({})

  const {shifts, loading, processing} = useSelector(
    (state) => state.shifts,
  )

  const [newShift, setNewShift] = useState({
    name: '',
    start_time: '',
    end_time: '',
  })

  const [activeModalComponent, setActiveModalComponent] = useState(null)

  useEffect(() => {
    fetchShift();
  }, [])

  const fetchShift = () => {
    dispatch(getShifts())
  }

  const addShiftInfo = (key, value, oldShift) => {
    let shift = {...oldShift}
    shift[key] = value
    setNewShift(shift)
  }

  useEffect(() => {
    if (!loading && !processing) {
      setShowModal(false)
      setNewShift({
        name: '',
        start_time: '',
        end_time: '',
      })
    }
  }, [shifts, processing, loading])

  const viewAssociatedItems = () => {
    setActiveModalComponent(ModalOptions.previewBookings)
    setShowModal(true)
  }

  const ModalOptions = {
    createShift: {
      title: () => 'Add Shift',
      buttonLabel: "Add",
      child: ({newShift}) => (
        <CampaignShiftForm addShiftInfo={addShiftInfo} shift={newShift}/>
      ),
      onConfirm: ({newShift}) => {
        dispatch(
          createShift({
            ...newShift,
            start_time: timeToUTCTimeString(newShift.start_time),
            end_time: timeToUTCTimeString(newShift.end_time),
          }),
        )
      },
      validate: (shift) => {
        return (
          (shift.name || '').trim().length > 1 &&
          (shift?.start_time || '').length === 5 &&
          (shift?.end_time || '').length === 5
        )
      },
    },
    deleteShift: {
      title: () => 'Delete Shift',
      buttonLabel: "Delete",
      child: () => <div>You are about to delete this shift are you sure?</div>,
      onConfirm: ({shiftId}) => {
        dispatch(removeShift(shiftId))
      },
      validate: () => true,
    },
    editShift: {
      title: () => 'Update Shift',
      buttonLabel: "Update",
      child: ({newShift}) => (
        <CampaignShiftForm addShiftInfo={addShiftInfo} shift={newShift} isEdit={true}
                           changeModal={viewAssociatedItems}/>
      ),
      onConfirm: ({newShift}) => {
        dispatch(
          updateShift({
            shiftId: newShift.id,
            data: {
              name: newShift.name,
              start_time: timeToUTCTimeString(newShift.start_time),
              end_time: timeToUTCTimeString(newShift.end_time),
            },
          }),
        )
      },
      validate: (shift) => {
        return (
          (shift.name || '').trim().length > 1 &&
          (shift?.start_time || '').length === 5 &&
          (shift?.end_time || '').length === 5
        )
      },
    },
    previewBookings: {
      title: (selectedShift) =>
        `${capitalizeFirstLetter(selectedShift.shift.name)} Shift Bookings`,
      child: ({shift}) => (
        <AssociatedBookings shift={shift}/>
      ),
    },
  }

  const onEditShift = (shift) => {
    setSelectedShift(shift);
    setNewShift({
      name: shift.name,
      start_time: utcToLocalTimeString(shift?.start_time, false),
      end_time: utcToLocalTimeString(shift?.end_time, false),
      id: shift.id,
    })
    setActiveModalComponent(ModalOptions.editShift)
    setShowModal(true)
  }

  const onPreviewBookings = (shift) => {
    //display bookings
    setSelectedShift(shift)
    setActiveModalComponent(ModalOptions.previewBookings)
    setShowModal(true)
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <div className="flex items-center justify-between w-ful">
                <h2 className="text-2xl text-white">Shifts</h2>
                <SemiTransparentButton
                  onClick={() => {
                    setShowModal(true)
                    setActiveModalComponent(ModalOptions.createShift)
                  }}
                >
                  + Add Shift
                </SemiTransparentButton>
              </div>
            </CustomCardHeader>
            <ShiftList
              onEdit={onEditShift}
              onPreviewBookings={onPreviewBookings}
            />
          </CustomCard>
        </div>
      </div>
      {showModal && (
        <CustomModal
          loading={processing}
          showModal={showModal}
          setShowModal={() => {
            setShowModal(false)
            setSelectedShift({})
          }}
          bodyClasses="max-w-xl"
          title={activeModalComponent?.title({shift})}
          children={activeModalComponent?.child({newShift, shift})}
          button={
            activeModalComponent.hasOwnProperty('onConfirm') ? <CustomButton
              disabled={!activeModalComponent?.validate(newShift)}
              onClick={() => {
                activeModalComponent?.onConfirm({
                  shift,
                  newShift,
                })
              }}
            >
              {activeModalComponent?.buttonLabel}
            </CustomButton> : null
          }
        />
      )}
    </div>
  )
}

export default Shifts
